var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRename(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.091,
    height: 15,
    viewBox: "0 0 14.091 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9735",
    "data-name": "Group 9735",
    transform: "translate(-239.363 -115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "flip_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24",
    d: "M124.091-906.364h-2.727a1.313,1.313,0,0,1-.963-.4,1.313,1.313,0,0,1-.4-.963v-9.545a1.313,1.313,0,0,1,.4-.963,1.313,1.313,0,0,1,.963-.4h2.727v1.364h-2.727v9.545h2.727ZM125.455-905v-15h1.364v15Z",
    transform: "translate(119.363 1035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "flip_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24-2",
    "data-name": "flip_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24",
    d: "M118-906.364h4.727a1.313,1.313,0,0,0,.963-.4,1.313,1.313,0,0,0,.4-.963v-9.545a1.313,1.313,0,0,0-.4-.963,1.313,1.313,0,0,0-.963-.4H118v1.364h4.727v9.545H118Z",
    transform: "translate(129.363 1035)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRename);
export default __webpack_public_path__ + "static/media/icon_rename.ef8c9376e2232da7a561f6a6da9e1ab4.svg";
export { ForwardRef as ReactComponent };